import React, { useContext } from 'react';
import { connect } from 'react-redux';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import { withRouter, Link } from 'react-router-dom';
import {
  shape, func, node, bool,
} from 'prop-types';

import Logo from '../Logo';
import List from '../List';
import { headerPreviewRightList } from '../../pages/utils/headerList';
import LanguageProvider from './LanguageProvider';

import { collapsedSidebarAction } from '../../actions';
import { logOut } from '../../actions/auth';
import mainLogo from '../../assets/img/logo-small.png';
import { rootAppPath } from '../../util/paths';
import { AbilityContext } from '../AbilityContext';

const PreviewHeader = (props) => {
  const { fetching, updatingMultiple, updating } = props.preview;
  const isLoading = fetching || updatingMultiple || updating;
  const disabledClass = isLoading ? 'disabled' : '';

  const abilityContext = useContext(AbilityContext);
  const onLogoutClick = () => props.logOut();

  const { displayName } = props.session.item;
  const listParams = {
    onLogoutClick,
    userName: displayName || '',
    abilityContext,
  };
  const {
    content, controls,
  } = props;
  const logo = {
    src: mainLogo,
    alt: '',
  };

  return (
    <AppBar position="static" className="rct-header">
      <Toolbar className="d-flex justify-content-between">
        <div key="1" className="d-flex align-items-center w-100 justify-between">
          <div className="site-logo">
            <Link to={rootAppPath}>
              <Logo logo={logo} />
            </Link>
          </div>
          <div className="flex justify-center block">
            {content}
          </div>
          <div className="lists-group flex justify-end block">
            <div className="flex items-center text-nowrap">
              <List
                dir="horizontal"
                disable={isLoading}
                className="d-flex align-center list-item-clear"
                dataSource={headerPreviewRightList(listParams)}
                last={<LanguageProvider />}
              />
              <div className={`controls ${disabledClass}`}>
                {controls}
              </div>
            </div>
          </div>
        </div>
      </Toolbar>
    </AppBar>
  );
};

PreviewHeader.propTypes = {
  session: shape({
    item: shape(),
  }).isRequired,
  preview: shape({
    fetching: bool,
    updatingMultiple: bool,
    updating: bool,
  }).isRequired,

  logOut: func.isRequired,
  content: node,
  controls: node,
};

PreviewHeader.defaultProps = {
  content: null,
  controls: null,
};

const mapStateToProps = state => ({
  preview: state.preview,
  settings: state.settings,
  navCollapsed: state.settings.navCollapsed,
  session: state.session,
});

const mapDispatchToProps = {
  logOut,
  collapsedSidebarAction,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PreviewHeader));
